import { OverlayScrollbarsComponent } from 'overlayscrollbars-react'

import 'overlayscrollbars/overlayscrollbars.css'

/**
 * NOTE: To limit content height, do one of either:
 * - Specify max-height on the children element
 * - Make parent/grandparent element a flex container and overflow auto..
 */

interface IOverlayScrollabarProps {
  scrollStyle?: string
  children: React.ReactNode
  overflow?: object
}

const OverlayScrollbar = ({
  children,
  scrollStyle,
  overflow = { y: 'scroll' }
}: IOverlayScrollabarProps) => {
  return (
    <OverlayScrollbarsComponent
      defer
      style={{ flex: '1' }}
      className={scrollStyle}
      options={{
        scrollbars: {
          theme: 'os-theme-dark',
          autoHide: 'never'
        },
        overflow
      }}
    >
      {children}
    </OverlayScrollbarsComponent>
  )
}

export default OverlayScrollbar
